import { Pipe, PipeTransform } from '@angular/core';
import { IAdditionalEmails } from '../interfaces';
import { ParkerStateService } from 'src/app/core/services/state/parker-state.service';

@Pipe({ name: 'additionalEmailList' })
export class AdditionalEmailsPipe implements PipeTransform {
  additionalEmailList: IAdditionalEmails[];
  emailDisplay: string = '';

  constructor(private parkerStateService: ParkerStateService) {
    this.additionalEmailList = this.parkerStateService.getAdditionalEmailData();
  }

  transform(parkerId: string) {
    if (!parkerId) {
      return '';
    }

    let ii = 0;
    let firstEmailFound = false;
    for (ii = 0; ii < this.additionalEmailList.length; ii++) {
      if (this.additionalEmailList[ii].parkerId === parkerId) {
        let thisEmail = '';

        if (firstEmailFound) {
          thisEmail += '\n';
        }

        firstEmailFound = true;

        let foundEmail = this.additionalEmailList[ii];

        if (foundEmail.name != '') thisEmail += foundEmail.name;

        if (foundEmail.emailAddress != '') thisEmail += ' - ' + foundEmail.emailAddress;

        this.emailDisplay += thisEmail;
      }
    }

    return this.emailDisplay;
  }
}
